// HOOKS
import { createContext, useState } from "react";

export const SelectedUsersContext = createContext({
  selectedUsers: [],
  setSelectedUsers: () => {},
  resetSelectedUsers: () => {},
  removeSelectedUser: () => {},
  addSelectedUser: () => {},
});

export const SelectedUsersProvider = ({ children }) => {
  const [selectedUsers, setSelectedUsers] = useState([]);

  const resetSelectedUsers = () => {
    setSelectedUsers([]);
  };

  const removeSelectedUser = (_id) => {
    setSelectedUsers(selectedUsers.filter((user) => user._id !== _id));
  };

  const addSelectedUser = (user) => {
    setSelectedUsers([...selectedUsers, user]);
  };

  return (
    <SelectedUsersContext.Provider
      value={{
        selectedUsers,
        setSelectedUsers,
        resetSelectedUsers,
        removeSelectedUser,
        addSelectedUser,
      }}
    >
      {children}
    </SelectedUsersContext.Provider>
  );
};
